import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { AppModal, dismissAppModal } from "../../../redux/appSlice"
import { V2L5AppIntro } from "@fusion-advantage/formrender"
import { initiateLogin } from "../../../redux/thunk/authThunk"
import { getLongCopyright } from "../../../lib/appInfo"
import { updateRenderState } from "../../../lib/relay/updateRenderState"

export const LxAppIntro = () => {
	const loading = useAppSelector(state => Boolean(state.app.ldng.login))
	const syncing = useAppSelector(state => Boolean(state.sync.startedAt !== null && state.sync.endedAt === null))
	const dispatch = useAppDispatch()
	useEffect(() => {
		dispatch(dismissAppModal(AppModal.Sync))
		dispatch(updateRenderState({
			t1NavOpen: false,
		}))
	}, [dispatch])
	return (
		<V2L5AppIntro
			loading={loading || syncing}
			canLogin={!loading && !syncing}
			onLoginClick={() => dispatch(initiateLogin())}
			copyright={getLongCopyright()}
		/>
	)
}
